import { State } from '../../types';

export const delaware: State = {
  name: 'Delaware',
  abbreviation: 'DE',
  terms: [
    {
      word: 'Christiana',
      phonetic: 'kris-tee-ANN-uh',
      audioUrl: '/audio/christiana.mp3',
      description: 'Community in northern Delaware'
    },
    {
      word: 'Frederica',
      phonetic: 'fred-uh-REE-kuh',
      // audioUrl: '/audio/frederica.mp3',
      description: 'This town\'s name is pronounced with the emphasis on the third syllable.'
    },
    {
      word: 'Hockessin',
      phonetic: 'ho-KESS-in',
      // audioUrl: '/audio/hockessin.mp3',
      description: 'The "h" is pronounced, and the emphasis is on the second syllable.'
    },
    {
      word: 'Houston',
      phonetic: 'HOW-ston',
      // audioUrl: '/audio/houston_de.mp3',
      description: 'Unlike the city in Texas, this Delaware town is pronounced with a "house" sound at the beginning.'
    },
    {
      word: 'Lewes',
      phonetic: 'LOO-iss',
      audioUrl: '/audio/lewes.mp3',
      description: 'Coastal city in Delaware'
    },
    {
      word: 'Newark',
      phonetic: 'NEW-ark',
      // audioUrl: '/audio/newark.mp3',
      description: 'This city\'s name is pronounced with two distinct syllables, unlike Newark, New Jersey.'
    },
    {
      word: 'Smyrna',
      phonetic: 'SMUR-nuh',
      // audioUrl: '/audio/smyrna.mp3',
      description: 'The "y" is pronounced as a short "u" sound, and the emphasis is on the first syllable.'
    }
  ]
};